import { makeStyles } from "@saleor/macaw-ui";

const useStyles = makeStyles(
  theme => ({
    label: {
      fontSize: "13px",
      lineHeight: "18px"
    },
    paper: {
      background: "#FFFFFF",
      boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.12)",
      borderRadius: "4px",
      padding: "0 4px",
      "& .MuiAutocomplete-option[data-focus='true']": {
        backgroundColor: theme.palette.background.default,
        color: theme.palette.info.main,
        "& .MuiTypography-root": {
          backgroundColor: theme.palette.background.default,
          color: theme.palette.info.main
        }
      },
      "&& .MuiAutocomplete-option[aria-selected='true']": {
        backgroundColor: "#EBF1FF",
        color: theme.palette.info.main,
        "& .MuiTypography-root": {
          backgroundColor: "#EBF1FF",
          color: theme.palette.info.main
        }
      }
    },
    root: {
      "& .MuiIconButton-root": {
        border: "none"
      },
      "& .MuiInputBase-root": {
        padding: "9px 0 9px 16px"
      },
      "& .MuiInputBase-input": {
        padding: "3px 4px 3px 0 !important",
        "&::placeholder": {
          fontSize: "14px",
          lineHeight: "18px",
          fontWeight: 400,
          color: theme.palette.grey[500]
        }
      },
      "& .MuiAutocomplete-popupIndicator": {
        marginTop: "2px"
      }
    }
  }),
  { name: "SingleAutocomplete" }
);

export default useStyles;
